import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  Box,
  Paper,
  Divider,
  Button,
  Tooltip,
} from '@mui/material';
import {
  // Close as CloseIcon,
  ContentCopy as ContentCopyIcon,
  Check as CheckIcon,
  Twitter as TwitterIcon,
  Facebook as FacebookIcon,
  LinkedIn as LinkedInIcon,
  WhatsApp as WhatsAppIcon,
} from '@mui/icons-material';
import QRCode from 'react-qr-code';
import { useSelector } from 'react-redux';

import PrimaryIcon from "Components/Common/PrimaryIcon";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";

const ShareDialog = ({ open, setOpen, post, shareLink }) => {
  const [copied, setCopied] = useState(false);

  const { Translation } = useSelector((state) => ({
    Translation: state.Translation.translation?.DiscussionHub || {}
  }));

  const handleCopy = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    });
  };

  const handleClose = () => {
    setOpen(false);
  };

  const socialPlatforms = [
    { name: 'Twitter', icon: <TwitterIcon />, color: '#1DA1F2' },
    { name: 'Facebook', icon: <FacebookIcon />, color: '#1877F2' },
    { name: 'LinkedIn', icon: <LinkedInIcon />, color: '#0A66C2' },
    { name: 'WhatsApp', icon: <WhatsAppIcon />, color: '#25D366' },
  ];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>
        {Translation?.ShareWithFriends}
        {/* <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
          Share with Friends
        </Typography> */}
        <IconButton onClick={() => handleClose()}>
          {" "}
          <PrimaryIcon
            icon={CloseIcon}
            color="white"
            height="14px"
            width="14px"
          />{" "}
        </IconButton>{" "}
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Typography variant="body1" color="secondary.light" fontWeight={500} sx={{ mb: 2 }}>
          {Translation?.AnyoneViewLinkContent}
        </Typography>

        {/* Copy Link Section */}
        <Paper
          variant="outlined"
          sx={{
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            borderRadius: '8px',
            bgcolor: 'background.default',
          }}
        >
          <Typography
            variant="body2"
            noWrap
            sx={{
              flexGrow: 1,
              mx: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: 'secondary.light',
              fontSize: '14px',
              fontWeight: 500
            }}
          >
            {shareLink}
          </Typography>
          <Tooltip title={copied ? Translation?.Copied : Translation?.CopyLink} placement="top">
            <Button
              variant="contained"
              onClick={handleCopy}
              startIcon={copied ? <CheckIcon /> : <ContentCopyIcon />}
              sx={{
                textTransform: 'none',
                boxShadow: 'none',
                bgcolor: copied ? 'success.main' : 'primary.main',
                '&:hover': {
                  bgcolor: copied ? 'success.dark' : 'primary.dark',
                },
              }}
            >
              {copied ? 'Copied' : 'Copy'}
            </Button>
          </Tooltip>
        </Paper>

        {/* <Divider sx={{ my: 3 }}>OR</Divider> */}

        {/* Social & QR Code Section */}
        {/* <Box sx={{ display: 'flex', gap: 4, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}> */}
          
          {/* Social Icons */}
          {/* <Box>
            <Typography variant="subtitle2" align="center" color="text.secondary" gutterBottom>
              Share via
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
              {socialPlatforms.map((platform) => (
                <Tooltip title={platform.name} key={platform.name}>
                  <IconButton
                    sx={{
                      color: platform.color,
                      bgcolor: `${platform.color}1A`, // Adds opacity for background
                      '&:hover': { bgcolor: `${platform.color}33` },
                    }}
                  >
                    {platform.icon}
                  </IconButton>
                </Tooltip>
              ))}
            </Box>
          </Box> */}
          
          {/* QR Code */}
          {/* <Box sx={{ textAlign: 'center' }}>
            <Typography variant="subtitle2" color="text.secondary" gutterBottom>
              Scan to share on mobile
            </Typography>
            <Box sx={{ p: 1, bgcolor: 'white', borderRadius: '8px', border: '1px solid #E0E0E0' }}>
              <QRCode value={shareLink} size={100} />
            </Box>
          </Box> */}

        {/* </Box> */}
      </DialogContent>
      <DialogActions align="center" mt={2}>
        <Button
          onClick={() => handleClose()}
          variant="outlined"
          color="secondary"
        >
          {Translation?.Cancel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ShareDialog;